import { render, staticRenderFns } from "./promotionListSetting.vue?vue&type=template&id=5b9befaa&scoped=true"
import script from "./promotionListSetting.vue?vue&type=script&lang=js"
export * from "./promotionListSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9befaa",
  null
  
)

export default component.exports